import { jsonldReviewBestRating } from './JsonldStore';

export const updateJsonldReviewBestRating = (value) => jsonldReviewBestRating.update((oldValue) => value);
